<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <!-- <b-link class="brand-logo">
        <b-img
          fluid
          src="@/assets/images/logo/Udara360-logo.png"
          width="180"
        />
      </b-link> -->
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex p-0"
      >

        <!-- <b-img
            fluid
            src="@/assets/images/logo/boi-logo.png"
            alt="Login V2"
            width="600"
          />
        </div> -->
        <div
          v-if="institution.loginPageBackgroundURL"
          class="auth-bg-image"
          role="img"
          aria-label="Institution background"
          :style="{
            backgroundImage: 'url(' + institution.loginPageBackgroundURL + ')',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: '100%',
            height: '100%',
          }"
        />

      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title class="mb-1 forgot-title">
            {{ $t('Forgot Password') }}
          </b-card-title>
          <!-- <b-card-text class="mb-2">
          Oops!, We know how fustrating this could be, but we'll take a short steps to recover it.
        </b-card-text> -->

          <b-card-text class="mb-2">
            {{ $t("Enter the email linked with your account and we'll send an email with instructions to reset your password.") }}
          </b-card-text>

          <Alert
            :show="showFormError"
            :message="errorMessage"
          />

          <!-- form -->
          <validation-observer ref="passwordRecovery">
            <b-form
              class="auth-forgot-password-form mt-2"
              @submit.prevent="recoverPassword"
            >
              <!-- email -->
              <InputField
                id="email"
                v-model="email"
                :label="$t('Email Address')"
                placeholder="john@company.com"
                type="email"
                error-name="Email Address"
                rules="required|email"
              />
              <!-- submit button -->
              <Button
                :label="$t('Next') + ' >'"
                size="lg"
                block
                :loading="isLoading"
                :disabled="isDisabled"
                @click="recoverPassword"
              />
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <b-link
              :to="{name:'auth-login'}"
              class="text-primary"
            >
              <feather-icon icon="ChevronLeftIcon" /> {{ $t('Back to Login') }}
            </b-link>
          </b-card-text>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BCardText, BCardTitle, BForm,
} from 'bootstrap-vue'
import { required } from '@validations'
// import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { mapActions, mapGetters } from 'vuex'
import { toastAlert } from '@core/mixins/toast'
import InputField from '../../forms/InputField.vue'
import Button from '../../components/button/Button.vue'
import Alert from '../../components/alert/Alert.vue'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BCardText,
    BCardTitle,
    BForm,
    ValidationObserver,
    InputField,
    Button,
    Alert,
  },
  mixins: [toastAlert],
  data() {
    return {
      email: '',
      isLoading: false,
      isDisabled: false,
      showFormError: false,
      errorMessage: '',
      required,
    }
  },
  computed: {
    ...mapGetters({
      institution: 'auth/getInstitution',
    }),
  },
  methods: {
    ...mapActions({
      validateEmailAndSendToken: 'auth/validateEmailAndSendToken',
    }),
    async recoverPassword() {
      this.$refs.passwordRecovery.validate().then(async success => {
        if (success) {
          try {
            this.showFormError = false
            this.isDisabled = true
            this.isLoading = true
            await this.validateEmailAndSendToken(this.email)
              .then(() => {
                this.$router.push({ name: 'password-verify-token', params: { user: this.email } })
              })
            this.isDisabled = false
            this.isLoading = false
            return true
          } catch (error) {
            error.response.data.errors.forEach(responseError => {
              this.errorMessage = responseError.errorMessage
            })
            this.showFormError = true
          } finally {
            this.isDisabled = false
            this.isLoading = false
          }
        }
        return false
      })
    },
  },
}
</script>
<style scoped>
.text-primary {
    color: var(--primary) !important;
  }
</style>
<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

</style>
